export default {
  find: {
    method: 'get',
    url: '/admincp/company/find?key=KEY&type=TYPE'
  }
}
